import { ClearFilesEvent, SurveyModel } from 'survey-core';
import { deleteFile } from '../../api/files/delete-file';
import { patchSubmission } from '../../api/submissions/patch-submission';
import { UserType } from '../../types';

export interface DeleteFileHandlerProps {
  options: ClearFilesEvent;
  urlSlug: string;
  publicId?: string;
  surveyModel?: SurveyModel;
  isSigner?: boolean;
  trackingId?: string;
}

// Set up file clear handler
export const deleteFileHandler = async ({
  options,
  urlSlug,
  publicId,
  trackingId,
  surveyModel,
  isSigner = false,
}: DeleteFileHandlerProps) => {
  try {
    if (!options.value) {
      return options.callback('success');
    }

    const filesToDelete = options.fileName
      ? options.value.filter((file: any) => file.name === options.fileName)
      : options.value;

    if (!filesToDelete || filesToDelete.length === 0) {
      return options.callback('success');
    }

    const deletePromises = filesToDelete.map(async (file: any) => {
      const fileName = file.content.split('/').pop();
      if (!fileName) {
        throw new Error('Invalid file URL');
      }

      if (trackingId) {
        // Trade references flow
        await deleteFile({
          urlSlug,
          trackingId,
          fileName,
        });
      } else if (publicId) {
        // Submission flow
        await deleteFile({
          urlSlug,
          publicId,
          fileName,
          isSigner,
        });
      } else {
        throw new Error('Either trackingId or publicId must be provided');
      }
    });

    await Promise.all(deletePromises);
    options.callback('success');

    // After successful delete, trigger a save (only for submission flow)
    if (publicId && surveyModel) {
      const userType = isSigner ? UserType.SIGNER : UserType.INITIAL_USER;
      await patchSubmission(urlSlug, publicId, surveyModel.data, userType);
    }
  } catch (error) {
    console.error('Error deleting files:', error);
    options.callback('error');
  }
};
